var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInvoiceGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9421,
    cy: 16.7363,
    r: 16.2637,
    fill: "#2DC24E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6893 21.1045L9.94648 17.3616L8.69885 18.6093L13.6893 23.5997L24.3833 12.9058L23.1356 11.6582L13.6893 21.1045Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInvoiceGreenTick);
export default __webpack_public_path__ + "static/media/dashboard_invoice_green_tick.7680dbfcbac04fe25d71dfef571f5b2e.svg";
export { ForwardRef as ReactComponent };